module.exports = __webpack_public_path__ + "media/images/new/see_favorites_in_search-f0f919d61d89a0a90cc92c2240730ca2.jpg";